import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Connexion réussie");
      navigate(user.role === "admin" ? "/admin" : user.role === "artist" ? "/espace-artiste" : "/espace-client");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Connexion" subtitle="Accédez à votre espace MYSE">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label className="text-white mb-2 block">Email</Label>
          <Input
            type="email"
            data-testid="login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-[#181820] border-white/10 text-white"
          />
        </div>
        <div>
          <div className="flex justify-between mb-2">
            <Label className="text-white">Mot de passe</Label>
            <Link to="/forgot-password" className="text-xs text-[#C9A24B] hover:underline" data-testid="forgot-link">
              Mot de passe oublié ?
            </Link>
          </div>
          <Input
            type="password"
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="bg-[#181820] border-white/10 text-white"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="login-submit-btn"
          className="w-full gold-bg text-black font-semibold rounded-full py-6 hover:opacity-90"
        >
          {loading ? "Connexion..." : "Se connecter"}
        </Button>
      </form>
      <p className="text-center text-sm text-[#A19E95] mt-6">
        Pas encore de compte ?{" "}
        <Link to="/inscription" className="text-[#C9A24B] hover:underline" data-testid="to-register-link">
          Créer un compte
        </Link>
      </p>
    </AuthLayout>
  );
}
